import suiteService from 'qreventos-suite/services';

class SuiteConfig {
  evento: number = 895;
  token: string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
  clientId: string = '93aaf1d1-ac5c-4972-9716-84b732213313-895';

  public constructor() {
    suiteService.clientId = this.clientId;
    suiteService.token = this.token;
  }
}

export default new SuiteConfig();
